<template>
  <SubmenuDropdown
    round
  >
    <a
      class="help-link"
      :href="helpLink.href"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get Help"
      @click="handleOnClick"
    >
      <div class="d-flex get-help-button">
        <DpplSvg file-name="platform/help" />
      </div>
    </a>
  </SubmenuDropdown>
</template>

<script>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import SubmenuDropdown from '@/components/editor/SubmenuDropdown.vue';

export default {
  name: 'GetHelpButton',
  components: {
    DpplSvg,
    SubmenuDropdown,
  },
  props: {
    getHelpLinks: { type: Array, default: () => [] },
  },
  emits: ['tracking-event'],
  computed: {
    helpLink() {
      return this.getHelpLinks[0]?.links[0] || {};
    },
  },
  methods: {
    handleOnClick() {
      this.$emit('tracking-event', {
        action: 'navLinkClick',
        args: { label: this.helpLink.title },
      });
    },
  },
};
</script>

<style scoped lang="less">
.get-help-button svg {
  width: 20px;
  height: 20px;
}
.help-link {
  all: unset;
}
</style>
